/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';

import { methodNameEnum } from '../../../../recoil/selectors/makePHPRequest';
import { checkIsActive } from '../../../../_metronic/_helpers';
import { permissionsSelector } from '../../../../recoil/selectors/permissionsSelector';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../../../services/rest/makeAPIRequest';

export function HeaderMenu({ layoutProps }) {
  const data = {
    call: methodNameEnum.GET_BUSINESS_DATA,
  };
  const businessData = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_DATA,
      payloadJsonString: JSON.stringify(data),
    })
  );
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const { role } = permissionsLoadable.contents;
  const location = useLocation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? 'menu-item-active' : '';
  };

  const canViewCallReporting = () => {
    if (businessData?.contents?.response?.data) {
      if (
        businessData?.contents?.response?.data?.result?.[0] &&
        businessData?.contents?.response?.data?.result?.[0]
          ?.onlyManagersCanViewCallReporting === 1
      ) {
        return role === 'superadmin' || role === 'admin' || role === 'manager';
      }
      if (
        businessData?.contents?.response?.data?.result?.[0] &&
        businessData?.contents?.response?.data?.result?.[0]
          ?.onlyManagersCanViewCallReporting === 0
      ) {
        return true;
      }
    } else {
      return false;
    }
  };

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/* begin::Header Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* Call Reporting -> Agent Summary */}
        {/* begin::1 Level */}
        {canViewCallReporting() && (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              '/call-reporting/agent-summary'
            )}`}
          >
            <NavLink className="menu-link" to="/call-reporting/agent-summary">
              <span className="menu-text">Call Reporting</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          </li>
        )}
        {/* end::1 Level */}

        {/* History -> Call History */}
        {/* begin::1 Level */}
        {(role === 'superadmin' || role === 'admin' || role === 'manager') && (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              '/history/call-history'
            )}`}
          >
            <NavLink className="menu-link" to="/history/call-history">
              <span className="menu-text">History</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          </li>
        )}
        {/* end::1 Level */}

        {/* Manage -> Agents */}
        {/* begin::1 Level */}
        {(role === 'superadmin' || role === 'admin' || role === 'manager') && (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              '/manage/agents'
            )}`}
          >
            <NavLink className="menu-link" to="/manage/agents">
              <span className="menu-text">Manage</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          </li>
        )}
        {/* end::1 Level */}

        {/* Billing -> Recurring Invoice */}
        {/* begin::1 Level */}
        {(role === 'superadmin' || role === 'admin' || role === 'manager') && (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              '/billing/subscription'
            )}`}
          >
            <NavLink className="menu-link" to="/billing/subscription">
              <span className="menu-text">Billing</span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          </li>
        )}
        {/* end::1 Level */}
      </ul>
      {/* end::Header Nav */}
    </div>
  );
}
